import {
  STAFF_MANAGEMENT_CONTENT,
  type StaffErrorKey,
} from '../../content/sections/staff-management.js';
import { ApiError } from '../../lib/http.js';

/* Classifica o erro num código estável — o texto mora só no catálogo bilíngue
   (`staff-management.ts`). Os códigos de negócio 409 (email_taken/last_super_admin/
   cannot_suspend_self) chegam no `ApiError.code` (staff-api.ts os repassa, snake_case do
   backend); auth/rede/genérico caem no fallback por status. Mapeados via `switch` para chaves em
   camelCase — não dá para indexar um `Record` com a chave snake_case sem violar
   `useNamingConvention` no catálogo. */
function staffErrorKey(err: unknown): StaffErrorKey {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'email_taken':
        return 'emailTaken';
      case 'last_super_admin':
        return 'lastSuperAdmin';
      case 'cannot_suspend_self':
        return 'cannotSuspendSelf';
      case 'unauthorized':
        return 'unauthorized';
      case 'not_found':
        return 'notFound';
      case 'network':
        return 'network';
      default:
        return 'default';
    }
  }
  return 'unexpected';
}

/**
 * Mensagem traduzida para a gestão de staff.
 *
 * O parâmetro `errors` é o mapa do locale corrente (`useStaffManagementContent().errors`); o
 * default pt-BR existe para chamadores fora de componente (testes unitários).
 */
export function staffErrorMessage(
  err: unknown,
  errors: Readonly<Record<StaffErrorKey, string>> = STAFF_MANAGEMENT_CONTENT['pt-BR'].errors,
): string {
  return errors[staffErrorKey(err)];
}
